import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getUnifiedLinkRpcContract = rpcContract({
  name: "getUnifiedLink",
  paramsSchema: v.object({
    linkId: v.string(),
  }),
  resultSchema: v.object({
    id: v.string(),
    created: v.string(), // ISO date string
    last_updated: v.string(), // ISO date string
    title: v.string(),
    url: v.string(),
    teaser: v.nullable(v.string()),
    priority: v.number(),
    exclusive: v.boolean(),
    influencer_id: v.string(),
    file_id: v.nullable(v.string()),
    thumbnail: v.nullable(v.string()),

    // Discount fields
    has_discount: v.boolean(),
    code: v.nullable(v.string()),
    brand_id: v.nullable(v.string()),
    published_at: v.nullable(v.string()), // ISO date string
    start_date: v.nullable(v.string()), // ISO date string
    end_date: v.nullable(v.string()), // ISO date string
    status: v.optional(v.union([v.literal("draft"), v.literal("live"), v.literal("upcoming"), v.literal("expired")])),

    // Premium content fields
    contentTier: v.picklist(["free", "premium"]),
    oneTimeProduct: v.optional(
      v.object({
        id: v.string(),
        priceCents: v.number(),
      }),
    ),

    // Relations
    promotion_brand: v.nullable(
      v.object({
        id: v.string(),
        name: v.string(),
        thumbnail: v.nullable(v.string()),
      }),
    ),
    promotion_file: v.nullable(
      v.object({
        id: v.string(),
        path: v.string(),
        thumbnail_path: v.nullable(v.string()),
        mime_type: v.string(),
      }),
    ),
  }),
});

export type GetUnifiedLinkParams = v.InferOutput<(typeof getUnifiedLinkRpcContract)["paramsSchema"]>;
export type GetUnifiedLinkResult = v.InferOutput<(typeof getUnifiedLinkRpcContract)["resultSchema"]>;
export type UnifiedLinkItem = GetUnifiedLinkResult;
